import createReducer from 'shared/utils/createReducer';

import { ADD_TOAST, UPDATE_TOAST } from '../actions/addToast';
import { REMOVE_TOAST } from '../actions/removeToast';

const initState = {
  list: [],
  limit: 3,
};

export default (prefix) => createReducer(initState, {
  [`${ prefix }_${ ADD_TOAST }`]: (state, { payload }) => ({
    ...state,
    list: [payload, ...state.list].slice(0, state.limit),
  }),

  [`${ prefix }_${ UPDATE_TOAST }`]: (state, { payload }) => ({
    ...state,
    list: state.list.map(item => item.id === payload.id ? payload : item),
  }),

  [REMOVE_TOAST]: (state, { payload: { id } }) => ({
    ...state,
    list: state.list.filter(({ id: curId }) => curId !== id),
  }),
});

